<template>
<span>
    <restaurant-details></restaurant-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import RestaurantDetails from '@/components/moduls/RestaurantDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'restaurant',
    components:{
        RestaurantDetails,
        PageFooter
    }

    
};
</script>


